import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "star, favorite, award" }, [
      _createElementVNode("path", {
        id: "vector",
        d: "M10.0001 1.25L12.5237 6.53282L18.3334 7.2978L14.0834 11.3277L15.1504 17.0833L10.0001 14.2912L4.8498 17.0833L5.91675 11.3277L1.66675 7.2978L7.47644 6.53282L10.0001 1.25Z",
        stroke: "#8E8E93",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ], -1)
  ])))
}
export default { render: render }